export default __webpack_public_path__ + "maps-examples-custom-callout-thumbnail-960-29f55de1bd5c942591d17692843f9410.png";